export default "__VITE_ASSET__sRmCR0Al__"